import { PaletteOptions } from '@mui/material/styles';
import { PrimaryColors } from '@/common/theme/constants';

// Augment the palette to include custom colors
declare module '@mui/material/styles' {
  interface Palette {
    radical: Palette['primary'];
    black: Palette['primary'];
    nearBlack: Palette['primary'];
    charcoal: Palette['primary'];
    obsidian: Palette['primary'];
    carbon: Palette['primary'];
    tundora: Palette['primary'];
    concrete: Palette['primary'];
    gravity: Palette['primary'];
    diamond: Palette['primary'];
    white: Palette['primary'];
    mediumGrey: Palette['primary'];
  }

  interface PaletteOptions {
    radical?: PaletteOptions['primary'];
    black?: PaletteOptions['primary'];
    nearBlack?: PaletteOptions['primary'];
    charcoal?: PaletteOptions['primary'];
    obsidian?: PaletteOptions['primary'];
    carbon?: PaletteOptions['primary'];
    tundora?: PaletteOptions['primary'];
    concrete?: PaletteOptions['primary'];
    gravity?: PaletteOptions['primary'];
    diamond?: PaletteOptions['primary'];
    white?: PaletteOptions['primary'];
    mediumGrey?: PaletteOptions['primary'];
  }
}

// Allow Button component to use custom colors
declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    radical: true;
    black: true;
    nearBlack: true;
    charcoal: true;
    obsidian: true;
    carbon: true;
    tundora: true;
    concrete: true;
    gravity: true;
    diamond: true;
    white: true;
    mediumGrey: true;
  }
}

export const palette: PaletteOptions = {
  mode: 'dark',
  // Define primary and secondary as palette color objects
  primary: {
    main: PrimaryColors.radical,
    contrastText: PrimaryColors.white,
  },
  secondary: {
    main: '#19857b',
  },
  error: {
    main: '#f44336',
  },
  background: {
    default: PrimaryColors.black,
  },
  text: {
    primary: PrimaryColors.white,
    secondary: PrimaryColors.white,
  },

  radical: {
    main: PrimaryColors.radical,
    contrastText: PrimaryColors.white,
  },
  black: {
    main: PrimaryColors.black,
    contrastText: PrimaryColors.white,
  },
  nearBlack: {
    main: PrimaryColors.nearBlack,
    contrastText: PrimaryColors.white,
  },
  charcoal: {
    main: PrimaryColors.charcoal,
    contrastText: PrimaryColors.white,
  },
  obsidian: {
    main: PrimaryColors.obsidian,
    contrastText: PrimaryColors.white,
  },
  carbon: {
    main: PrimaryColors.carbon,
    contrastText: PrimaryColors.white,
  },
  tundora: {
    main: PrimaryColors.tundora,
    contrastText: PrimaryColors.white,
  },
  concrete: {
    main: PrimaryColors.concrete,
    contrastText: PrimaryColors.black,
  },
  gravity: {
    main: PrimaryColors.gravity,
    contrastText: PrimaryColors.black,
  },
  diamond: {
    main: PrimaryColors.diamond,
    contrastText: PrimaryColors.black,
  },
  white: {
    main: PrimaryColors.white,
    contrastText: PrimaryColors.black,
  },
  mediumGrey: {
    main: PrimaryColors.grey,
    contrastText: PrimaryColors.white,
  },
};
